import { ChangePasswordValues } from './types';

export const initialValues: ChangePasswordValues = {
  currentPassword: '',
  newPassword: '',
  confirmPassword: '',
};
